<div class="db-onboarding-download-wrap">
  <div class="db-onboarding-download-left">
    <div>
      <h2>Try AI Builder Pro<br class="mobile"/> for free for 7 days</h2>
      <p>Edit your website, generate more content and images,<br *ngIf="!isMobile"/> and host a superfast website on 10Web. Own all the<br *ngIf="!isMobile"/> content and images you generate.</p>
  <!--    <div class="db-black-offer-banner mt12">
        <p>Black Friday Special: <span>+30% off first payment</span></p>
      </div>-->
      <p class="db-subhead mt20 mb8">AI Builder</p>
      <div class="db-ai-assistant-plugin-download-dialog__steps-wrap">
        <div class="db-ai-assistant-plugin-download-dialog__step"
             (click)="step?.id !== 3 && changeFeature(step.id)"
             *ngFor="let step of aiAssistantStep" [ngClass]="{'active': !isMobile && step?.id === activeFeature && step?.id !== 3, 'db-not-clicked': step?.id === 3}">
          <div class="db-step-wrap">
            <span class="db-icon-wrap"><i class="db-icon db-icon-ds-checkmark"></i></span>
            <span [ngClass]="{'with-gradient': step?.id === 3 && !!customDomainFlow}">{{step.title}}</span>
          </div>
        </div>
      </div>
      <p class="db-subhead mt20 mb8">Unlock all of 10Web</p>

      <ul class="points">
        <li>
          <span class="db-icon-wrap"><i class="db-icon db-icon-ds-checkmark"></i></span>
          <div>
            <p>Get a reliable Google Cloud Partner hosting</p>
          </div>
        </li>
        <li>
          <span class="db-icon-wrap"><i class="db-icon db-icon-ds-checkmark"></i></span>
          <div>
            <p>Get 90+ PageSpeed with 10Web Booster</p>
          </div>
        </li>
        <li>
          <span class="db-icon-wrap"><i class="db-icon db-icon-ds-checkmark"></i></span>
          <div>
            <p>Enable real-time automated backups</p>
          </div>
        </li>
      </ul>

      <div class="db-button-cont">
        <div class="cancel-anytime">
          <p><b>Cancel Anytime.</b> We will send you a reminder email 24 hours<br/> before the end of the period.</p>
        </div>
        <a class="ds-btn-black rectangle mt30"
           [ngClass]="{'ds-btn-l mb30': !!isMobile, 'ds-btn-xl': !isMobile}"
           (click)="resizeToNormal(); onStepChange.emit('plans')">
          <span>{{'Try 10Web pro for 7 days' | lowerCaseSpecificWords}}</span>
        </a>
      </div>
    </div>
  </div>
</div>
